import { gql } from '@apollo/client';
import {
  OrderInvoices_GetOrderInvoiceGrossProfitQuery,
  OrderInvoices_GetOrderInvoiceGrossProfitQueryVariables,
} from '@/types';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';

export const GET_ORDER_INVOICE_GROSS_PROFIT_QUERY = gql`
  query OrderInvoices_GetOrderInvoiceGrossProfit($invoiceUUID: uuid!) {
    getInvoiceGrossProfit(order_invoice_id: $invoiceUUID) {
      gross_profit {
        percentage
        amount_in_micros
        currency_code
      }
    }
  }
`;

export const useGetOrderInvoiceGrossProfit = (invoiceUUID: string) => {
  const { data, loading, error } = useWrappedQuery<
    OrderInvoices_GetOrderInvoiceGrossProfitQuery,
    OrderInvoices_GetOrderInvoiceGrossProfitQueryVariables
  >(GET_ORDER_INVOICE_GROSS_PROFIT_QUERY, {
    fetchPolicy: 'cache-and-network',
    variables: {
      invoiceUUID,
    },
  });

  return {
    error,
    grossProfit: data?.getInvoiceGrossProfit?.gross_profit,
    loading,
  };
};
